import { Component, ElementRef, ViewChild } from '@angular/core';
import { CourseService } from '../../../pages/courses/course.service';
import { Store } from '@ngrx/store';
import { selectCourseId } from '../../../pages/courses/create-courses/store/course.selector';
import { take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { reviewTextValidator } from '../../../utils/create_course_validators/other/otherValidators';

import { ToasterService } from '../../../providers/toaster/toaster.service';
import { CoursePreviewRefreshService } from '../../../providers/course-preview-refresh.service';

@Component({
  selector: 'app-review',
  standalone: true,
  imports: [CommonModule, FormsModule,ReactiveFormsModule],
  templateUrl: './review.component.html',
  styleUrl: './review.component.css'
})
export class ReviewComponent {

  reviewsList: any = []
  courseId: any;
  reviewForm!: FormGroup
  @ViewChild('reviewModal') reviewModal!: ElementRef<HTMLDialogElement>;
  reviewModelElem!: HTMLDialogElement;
  usersList: any = [];
  isreqSending: boolean = false;
  submitted = false;


  ratingPointers = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  constructor(private courseApiService: CourseService, private store: Store, private fb: FormBuilder,
    private toasterService: ToasterService,
    private previewRefresh: CoursePreviewRefreshService
  ) {
    this.getUsers();
    this.store.select(selectCourseId).subscribe((id) => {
      if (id) {
        this.courseId = id;
        this.getData(this.courseId);
      }
    });
    this.reviewForm = this.fb.group({
      user_id: ['', Validators.required],
      rating: [5, Validators.required],
      review: ['', [Validators.required, reviewTextValidator()]]
    });

  }


  ngOnInit(): void {

  }


  ngAfterViewInit() {
    this.reviewModelElem = this.reviewModal.nativeElement;
  }

  getData(id: any) {
    this.courseApiService.getReviews(id).subscribe((res: any) => {
      try {
        if (res.body.status === 'success') {
          this.reviewsList = res.body.data.map((item: any) => ({ ...item, rating: parseFloat(item.rating) }));
        }
      } catch (error) {

      }
    });
  }

  getUsers() {
    this.courseApiService.getUsers().subscribe((res: any) => {
      try {
        if (res.body.status === 'success') {
          this.usersList = res.body.data;
        }
      } catch (error) {
      }
    });
  }
  saveReview(){

    this.submitted = true;

    if (this.reviewForm.invalid) {
      this.reviewForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields');
      return;
    }

        

      const formData = new FormData();
      Object.keys(this.reviewForm.value).forEach(key => {
        formData.append(key, this.reviewForm.value[key]);
      });
      formData.append('course_id', this.courseId);
      this.isreqSending = true;
      this.courseApiService.addReviews(formData).subscribe((res: any) => {
        try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Review Added', res.body.message ?? 'Review added successfully');
          this.restForm();
          this.getData(this.courseId);
          this.previewRefresh.trigger(this.courseId, 'review');
            
        }
        } catch (error) {
          
        }
        this.isreqSending = false;
      })
    
  }

  togglePublish(id: any, value: any) {
    let isPublish = value == true ? 'inactive' : 'active';
    let formData = new FormData();
    formData.append('id', id);
    formData.append('status', isPublish);
    this.courseApiService.setIsPublished(formData).subscribe((res: any) => {
      try {
      if (res.body.status == "success") {
        this.toasterService.setToaster('success', 'Status Updated', res.body.message ?? 'Status updated successfully');
        this.getData(this.courseId);
        this.previewRefresh.trigger(this.courseId, 'review-status');
      }
      } catch (error) {
        
      }
    }) 
  }


  restForm() {
    this.reviewForm.reset({
      user_id: '',
      rating: 5,
      review: ''
    });
    this.submitted = false;
    this.reviewModelElem.close();
  }


}
